import { ReactElement, ReactNode } from "react";

interface Props {
  eyebrow?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}

export function PageShell({
  eyebrow,
  title,
  subtitle,
  actions,
  children,
}: Props): ReactElement {
  return (
    <div
      className="min-h-screen relative"
      style={{
        background:
          "radial-gradient(ellipse 600px 300px at 50% -100px, rgb(241 245 249 / 0.6), transparent 60%), rgb(248 250 252 / 0.4)",
      }}
    >
      <style>{`
        @keyframes apiKeysFadeIn {
          from { opacity: 0; transform: translateY(8px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .api-keys-fade {
          animation: apiKeysFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
        .api-keys-fade-delay {
          opacity: 0;
          animation: apiKeysFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.08s forwards;
        }
      `}</style>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10 relative">
        <header className="api-keys-fade flex flex-col gap-4 md:flex-row md:items-end md:justify-between mb-8 pb-6 border-b border-slate-200">
          <div className="relative">
            <div
              aria-hidden
              className="absolute -left-3 top-2 h-4 w-px bg-slate-900"
            />
            {eyebrow && (
              <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500 font-semibold mb-1.5">
                {eyebrow}
              </div>
            )}
            <h1 className="text-3xl font-semibold text-slate-900 tracking-tight">
              {title}
            </h1>
            {subtitle && (
              <p className="mt-1.5 text-sm text-slate-500 max-w-2xl">
                {subtitle}
              </p>
            )}
          </div>
          {actions && (
            <div className="flex items-center gap-2 shrink-0">{actions}</div>
          )}
        </header>
        <div className="api-keys-fade-delay">{children}</div>
      </div>
    </div>
  );
}
